var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Main',[_c('h1',{staticClass:"text-green-dark margin-t-0",class:{
      'font-54': _vm.$vuetify.breakpoint.smAndUp,
      'font-40': _vm.$vuetify.breakpoint.xs,
    },style:({ 'line-height': 1 })},[_vm._v(" Our Story ")]),_c('v-timeline',{attrs:{"align-top":"","dense":""}},_vm._l((_vm.timeline),function(event,eventIndex){return _c('OurStoryEvent',{key:((event.date) + "-" + eventIndex),attrs:{"event":event}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }